export default __webpack_public_path__ + "static/media/les_andelys04.397f1820.jpg";